module.exports = __webpack_public_path__ + "media/images/flags/so-88ec96340d618ef1b92038d0c1a841bf.svg";